import {createContext, ReactNode, useContext, useState} from "react";
import {useRPC, useSocket} from "../SocketContext";
import {rpc_getWhitelist} from "../rpc";
import {WhitelistData} from "../whitelist/interfaces";
import {useWatcher} from "../../../hooks/useWatcher";

const Context = createContext<WhitelistContextData>(null!);

export default function WhitelistContext(props: {children: ReactNode}) {
    const socket = useSocket()

    const [whitelist, setWhitelist] = useState<WhitelistData>({})

    useWatcher(socket.isConnected, () => {
        if (socket.isConnected){
            load()
        }
    })

    useRPC(socket, "UpdateWhitelist", (data: WhitelistData) => {
        //console.log("UpdateWhitelist", data)
        if (data){
            setWhitelist(data)
        }
        else{
            load()
        }
    })

    const load = () => {
        rpc_getWhitelist(socket).then(whitelist => {
            if (whitelist){
                setWhitelist(whitelist)
            }
        })
    }

    const context: WhitelistContextData = {
        data: whitelist,
        reload: load
    }

    return (
        <Context.Provider value={context}>
            {props.children}
        </Context.Provider>
    )
}

export const useWhitelist = () => useContext(Context)

interface WhitelistContextData{
    data: WhitelistData
    reload: () => void
}